import { createContext, useContext } from 'react';
import lampImg from '../../styles/assets/img/chat/lamp.svg';
import lampNovartisImg from '../../styles/assets/img/chat/lamp-nvs.svg';
import novartisLogo from '../../styles/assets/img/chat/nvs-logo.svg';

// Chat skins. Colors live in _chat.scss under .chat-theme-<name>; this file holds what
// CSS can't change (multi-color artwork) and each skin's default content.
// Default content is used when the matching Chat.* config entry is not set.
export const CHAT_THEMES = {
    default: {
        className: '',
        assets: { lamp: lampImg },
        content: {},
    },
    novartis: {
        className: 'chat-theme-novartis',
        assets: { lamp: lampNovartisImg },
        content: {
            LogoUrl: novartisLogo,
            LogoAlt: 'Novartis',
            LauncherTitle: "I'm Geniee, Your Novartis Access Guide",
            Suggestions: [
                'What are the **top HCP opportunities** by geography?',
                'What are the most **recent coverage changes** in my territory?',
                'Who are the **top payers** for a specific HCP?',
                'Who are the **top HCPs** for a specific payer?',
                'What is the **payer mix** for a specific HCP?',
            ],
        },
    },
};

/** Looks up a skin by name (case-insensitive), falling back to the default skin. */
export function getChatTheme(name) {
    return CHAT_THEMES[String(name || '').trim().toLowerCase()] || CHAT_THEMES.default;
}

/**
 * Picks the skin name: REACT_APP_CHAT_THEME (for local development) wins over the
 * Chat.Theme config value.
 */
export function resolveChatThemeName(configTheme) {
    return process.env.REACT_APP_CHAT_THEME || configTheme || 'default';
}

export const ChatThemeContext = createContext(CHAT_THEMES.default);

export function useChatTheme() {
    return useContext(ChatThemeContext);
}
